import { useLocation } from 'react-router-dom';
import PublicSliceGuard from '@/components/PublicSliceGuard';
import type { ReactNode } from 'react';

export default function GuardedRoute({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  return <PublicSliceGuard pathname={pathname}>{children}</PublicSliceGuard>;
}
